import React, { useState } from 'react';
// import { TreeSelect } from 'antd';
import styled from 'styled-components'
import Select from 'react-select'

interface Props{
    onChange(option:Option[]):void
    value: string[]
    options: string[] // todas as opcoes
}

interface Option{
    value: string
    label: string
}



const MultipleSelection = ({onChange, value=[], options=[]}:Props) => {
    //defaultValue={options.map(option => ({value:option, label:option} as Option))}
    return <Select 
                onChange={onChange}
                value={value.map(option => ({value:option, label:option} as Option))}
                options={options.map(option => ({value:option, label:option} as Option))}
                isMulti
                multi={true}
            />
}

export {Option};

export default MultipleSelection

const MyDiv = styled.div`
    /* .ant-select-dropdown, .ant-tree-select-dropdown, 
    .ant-select-dropdown-placement-bottomLeft, .slide-up-leave, .slide-up-leave-active, .slide-up,  
    ant-select-tree-treenode ant-select-tree-treenode-switcher-open ant-select-tree-treenode-leaf-last */
    .ant-select-selection-search, .ant-select-dropdown, .ant-tree-select-dropdown, 
    .ant-select-dropdown-placement-bottomLeft, .slide-up-leave, .slide-up-leave-active, .slide-up{
        margin-bottom: 10px;
        border: 1px solid black;
    }
    .ant-select-tree, .ant-select-tree-treenode{
        background-color: #b6a4a4;
    }
    /* ant-tree-select-dropdown ant-select-dropdown-placement-bottomLeft  slide-up-leave slide-up-leave-active slide-up */
    /* }; */
`;